import { createFileRoute } from "@tanstack/react-router";
import { SprzHdParamsListPage } from "@/features/reports/sprz-hd-params-list-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/sprz-wybranych-blozow/parametry/")({
	component: SprzHdParamsListPage,
	beforeLoad: async ({ context, location }) => {
		// Konfiguracja ma wezszy dostep niz sam raport (purchaser czyta raport, ale
		// nie edytuje parametrow), stad element `page.*`, nie sidebarowy.
		await ensureElementVisible(
			context.queryClient,
			"page.raporty.sprz-wybranych-blozow.konfiguracja",
			location.pathname,
		);
	},
});
